import { render, staticRenderFns } from "./curSale-warehouse-discard-edit.vue?vue&type=template&id=68e5c650&scoped=true"
import script from "./curSale-warehouse-discard-edit.vue?vue&type=script&lang=js"
export * from "./curSale-warehouse-discard-edit.vue?vue&type=script&lang=js"
import style0 from "./curSale-warehouse-discard-edit.vue?vue&type=style&index=0&id=68e5c650&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5c650",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e5c650')) {
      api.createRecord('68e5c650', component.options)
    } else {
      api.reload('68e5c650', component.options)
    }
    module.hot.accept("./curSale-warehouse-discard-edit.vue?vue&type=template&id=68e5c650&scoped=true", function () {
      api.rerender('68e5c650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/warehouse-management/curSale-warehouse-store/curSale-warehouse-discard-edit.vue"
export default component.exports